export interface NewsItem {
  title: string;
  description: string;
  image: string;
  labels: string[];
}
export const NEWS_LABELS: string[] = [
  'News',
  'Events',
];
